import React from "react";
import {
  MdWeb,
  MdViewAgenda,
  MdArticle,
  MdBuild,
  MdBusiness,
  MdAttachMoney,
  MdShowChart,
  MdEmail,
  MdInbox,
  MdInventory2,
  MdViewModule,
  MdCategory,
  MdLibraryBooks,
  MdWork,
  MdPhoto,
  MdCampaign,
} from "react-icons/md";

import HeaderPage from "views/admin/header";
import FooterPage from "views/admin/footer";
import HomePage from "views/admin/home";
import ServicesPage from "views/admin/services";
import CompanyPage from "views/admin/company";
import PricingPage from "views/admin/pricing";
import DynamicPricingPage from "views/admin/pricing-dynamic";
import ProductsPage from "views/admin/products";
import ProductsTwoPage from "views/admin/products-two";
import ProductsThreePage from "views/admin/products-three";
import ContactPage from "views/admin/contact";
import EnquiryList from "views/admin/enquiries";
import ArticlesPage from "views/admin/articles";
import CasesPage from "views/admin/cases";
import ResourcesPageCms from "views/admin/resources-page";
import CasesPageCms from "views/admin/cases-page";
import NewsletterIssuesPage from "views/admin/newsletter-issues";
import NewsletterEntriesPage from "views/admin/newsletter-entries";
import NewsletterPageCms from "views/admin/newsletter-page";
import SignIn from "views/auth/SignIn";

const icon = (El) => <El className="h-6 w-6" />;

const routes = [
  {
    name: "Header",
    layout: "/admin",
    path: "header",
    icon: icon(MdWeb),
    component: <HeaderPage />,
  },
  {
    name: "Home",
    layout: "/admin",
    path: "home",
    icon: icon(MdArticle),
    component: <HomePage />,
  },
  {
    name: "Services",
    layout: "/admin",
    path: "services",
    icon: icon(MdBuild),
    component: <ServicesPage />,
  },
  {
    name: "Company",
    layout: "/admin",
    path: "company",
    icon: icon(MdBusiness),
    component: <CompanyPage />,
  },
  {
    name: "Pricing",
    icon: icon(MdAttachMoney),
    children: [
      {
        name: "Fixed Pricing",
        layout: "/admin",
        path: "pricing",
        icon: icon(MdAttachMoney),
        component: <PricingPage />,
      },
      {
        name: "Dynamic Pricing",
        layout: "/admin",
        path: "pricing-dynamic",
        icon: icon(MdShowChart),
        component: <DynamicPricingPage />,
      },
    ],
  },
  {
    name: "Products",
    icon: icon(MdInventory2),
    children: [
      {
        name: "Product One",
        layout: "/admin",
        path: "products",
        icon: icon(MdInventory2),
        component: <ProductsPage />,
      },
      {
        name: "Product Two",
        layout: "/admin",
        path: "products-two",
        icon: icon(MdViewModule),
        component: <ProductsTwoPage />,
      },
      {
        name: "Product Three",
        layout: "/admin",
        path: "products-three",
        icon: icon(MdCategory),
        component: <ProductsThreePage />,
      },
    ],
  },
  {
    name: "Resources",
    icon: icon(MdLibraryBooks),
    children: [
      {
        name: "Articles",
        layout: "/admin",
        path: "articles",
        icon: icon(MdLibraryBooks),
        component: <ArticlesPage />,
      },
      {
        name: "Page",
        layout: "/admin",
        path: "resources-page",
        icon: icon(MdPhoto),
        component: <ResourcesPageCms />,
      },
    ],
  },
  {
    name: "Cases",
    icon: icon(MdWork),
    children: [
      {
        name: "Customer cases",
        layout: "/admin",
        path: "cases",
        icon: icon(MdWork),
        component: <CasesPage />,
      },
      {
        name: "Page",
        layout: "/admin",
        path: "cases-page",
        icon: icon(MdPhoto),
        component: <CasesPageCms />,
      },
    ],
  },
  {
    name: "Newsletter",
    icon: icon(MdCampaign),
    children: [
      {
        name: "Issues",
        layout: "/admin",
        path: "newsletter-issues",
        icon: icon(MdCampaign),
        component: <NewsletterIssuesPage />,
      },
      {
        name: "Entries",
        layout: "/admin",
        path: "newsletter-entries",
        icon: icon(MdEmail),
        component: <NewsletterEntriesPage />,
      },
      {
        name: "Page",
        layout: "/admin",
        path: "newsletter-page",
        icon: icon(MdPhoto),
        component: <NewsletterPageCms />,
      },
    ],
  },
  {
    name: "Contact",
    layout: "/admin",
    path: "contact",
    icon: icon(MdEmail),
    component: <ContactPage />,
  },
  {
    name: "Enquiries",
    layout: "/admin",
    path: "enquiries",
    icon: icon(MdInbox),
    component: <EnquiryList />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: null,
    component: <SignIn />,
    hidden: true,
  },
  {
    name: "Footer",
    layout: "/admin",
    path: "footer",
    icon: icon(MdViewAgenda),
    component: <FooterPage />,
  },
];

export function flattenRoutes(list = routes, parent = "") {
  return list.flatMap((route) => {
    const named = parent && route.path ? { ...route, menuLabel: `${parent} · ${route.name}` } : route;
    return route.children?.length
      ? [named, ...flattenRoutes(route.children, route.name)]
      : [named];
  });
}

export function adminPages(list = routes) {
  return flattenRoutes(list).filter(
    (route) => route.layout === "/admin" && route.path && route.component && !route.hidden
  );
}

export default routes;
